import { BN } from '@distributedlab/tools'

export const ZERO_BN = BN.fromRaw(0)
